
import { getFunctions, httpsCallable } from "firebase/functions";


// export const sendEmail = async (to, subject, body, attachments = []) => {
//   try {
//     const result = await callFunction("sendEmailMailerSend", {
//       to,
//       subject,
//       body,
//       attachments,
//     });
//     return result.data;
//   } catch (err) {
//     console.error("❌ Error calling function sendEmailMailerSend:", err);
//     throw err;
//   }
// };

export const sendEmail = async ({ to, subject, bodyHtml, bodyText, attachments = [] }) => {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "sendEmailMailerSend");
  return callable({ to, subject, bodyHtml, bodyText, attachments });
};

